import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { PlanCard } from './PlanCard'

import {
  Paper,
  PaperHeadline,
  PaperContent,
  Text,
  Link,
  Icon,
  Button,
  Input,
  Form,
} from '../../'


export class PetBestInsuranceCard extends React.PureComponent {
  static propTypes = {
    petName: PropTypes.string,
    email: PropTypes.string,
    samplePolicy: PropTypes.string,
    showAPIFailureScreen: PropTypes.bool,
    showSuccessScreen: PropTypes.bool,
    plusOptionProps: PropTypes.shape({
      price: PropTypes.string,
      plan: PropTypes.string,
      deductible: PropTypes.string,
      limit: PropTypes.string,
      reimbursement: PropTypes.string,
      coverageText: PropTypes.string,
      optionLabel: PropTypes.string,
      optionActive: PropTypes.bool,
      onClick: PropTypes.func,
      planDetails: PropTypes.string,
    }),
    essentialOptionProps: PropTypes.shape({
      price: PropTypes.string,
      plan: PropTypes.string,
      deductible: PropTypes.string,
      limit: PropTypes.string,
      reimbursement: PropTypes.string,
      coverageText: PropTypes.string,
      optionLabel: PropTypes.string,
      optionActive: PropTypes.bool,
      onClick: PropTypes.func,
      planDetails: PropTypes.string,
    }),
    eliteOptionProps: PropTypes.shape({
      price: PropTypes.string,
      plan: PropTypes.string,
      deductible: PropTypes.string,
      limit: PropTypes.string,
      reimbursement: PropTypes.string,
      coverageText: PropTypes.string,
      optionLabel: PropTypes.string,
      optionActive: PropTypes.bool,
      onClick: PropTypes.func,
      planDetails: PropTypes.string,
        }),
    selectedPlan: PropTypes.string,
    skipButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    addButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    tryAgainButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    reviewPageButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    emailInputProps: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func,
      name: PropTypes.string,
      error: PropTypes.bool,
      hint: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
      id: PropTypes.string
    }),
    sendQuoteButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    isSkipped: PropTypes.bool,
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    petName: 'Rachael',
    email: "xyz@abc.com"
  }

  render() {
    const {
      petName,
      selectedPlan,
      samplePolicy,
      showAPIFailureScreen,
      email,
      showSuccessScreen,
      skipButtonProps,
      addButtonProps,
      tryAgainButtonProps,
      reviewPageButtonProps,
      plusOptionProps,
      eliteOptionProps,
      essentialOptionProps,
      sendQuoteButtonProps,
      emailInputProps,
      isSkipped,
      id,
      style,
      refProp,
      className
    } = this.props

    return (
      <Paper
        id={id}
        className={cn("ui-pet-best-insurance-card", className)}
        style={style}
        ref={refProp}
        type={Paper.Types.framed}
      >
        <PaperHeadline>Pet Insurance Add-Ons</PaperHeadline>

        <PaperContent>
          {!showAPIFailureScreen && !showSuccessScreen && (<>
            <Text type={Text.Types.headline}>
              Protect {petName} with an accident & illness pet insurance policy from Pets Best
              <br />
              <Link href='https://www.petsbest.com/underwriters-licensing' target='_blank'>Underwriting</Link>
            </Text>
            <div className='ui-pet-best-insurance-card__add-on'>
              <PlanCard
                optionActive={selectedPlan === essentialOptionProps.plan.toLowerCase()}
                selectPlanProps={essentialOptionProps.onClick}
                planDetails='Optional benefits not included'
                coverageText='Accidents, Illnesses, Cancer, Hereditary Conditions, Emergency Care, Surgeries & Rx Meds'
                {...essentialOptionProps}
              />
              <PlanCard
                optionActive={selectedPlan === plusOptionProps.plan.toLowerCase()}
                selectPlanProps={plusOptionProps.onClick}
                planDetails='Includes coverage for Accident & Illness Exam Fees'
                coverageText='Accidents, Illnesses, Cancer, Hereditary Conditions, Emergency Care, Surgeries, Rx Meds, Accident & Illness Exam Fees'
                {...plusOptionProps}
              />
              <PlanCard
                optionActive={selectedPlan === eliteOptionProps.plan.toLowerCase()}
                selectPlanProps={eliteOptionProps.onClick}
                planDetails='Includes coverage for Accident & Illness Exam Fees and Rehab'
                coverageText='Accidents, Illnesses, Cancer, Hereditary Conditions, Emergency Care, Surgeries, Rx Meds, Accident & Illness Exam Fees, Rehabilitative, Acupuncture & Chiropractic Coverage'
                {...eliteOptionProps}
              />
            </div>

            {!isSkipped && (<div className='ui-pet-best-insurance-card__actions'>
              <p {...skipButtonProps}>
                Skip for Now
              </p>
              <Button color={Button.Colors.tertiary} {...addButtonProps}>
                Add {selectedPlan} Insurance Coverage
              </Button>
            </div>)}

            {isSkipped && (<Form className='ui-pet-best-insurance-card__form'>
              <Text type={Text.Types.title}>
                Want to come back to your quote later? We’ll send your Pets Best quote to:
              </Text>

              <Input
                type='email'
                label='Email Address'
                {...emailInputProps}
              />

              <div className='ui-pet-best-insurance-card__actions'>
                <p {...skipButtonProps}>
                  No Thanks
                </p>
                <Button color={Button.Colors.tertiary} {...sendQuoteButtonProps}>
                  Send My Quote
                </Button>
              </div>
              <Text type={Text.Types.caption}>
                By clicking 'Send My Quote', you agree to receive this quote and related pet insurance information via email.
              </Text>
            </Form>)}

            <div className='ui-pet-best-insurance-card__verbiage'>
              <Text>
                The insurance plans available through this agency are limited to specific plan types.
                For additional plan options offered by Pets Best Insurance Services, LLC, please visit <Link href='https://www.petsbest.com' target='_blank'>www.petsbest.com</Link>
              </Text>
              <Text>
                View a <Link href={samplePolicy} target='_blank'>Sample Policy</Link>
              </Text>
              <Text>
                PetPlace is Powered by PTZ Insurance Agency, Ltd (NPN: 5328528; CA licensed: 0E36937) a licensed insurance agency that
                does not underwrite pet insurance or pay claims but receives compensation on sale and/or renewal.
              </Text>
              <Text>
                Waiting periods, annual deductible, co-insurance, benefit limits, and exclusions may apply.
                For all terms visit <Link href='https://www.petsbest.com/policy' target='_blank'>www.petsbest.com/policy</Link>. Products, schedules, discounts, and rates may vary and are
                subject to change. More information is available at checkout.
                Premiums are based on and may increase or decrease due to the age of your pet, the species or breed of your
                pet, and your home address.
              </Text>
              <Text>
                Pet insurance coverage offered and administered by Pets Best Insurance Services,
                LLC is underwritten by American Pet Insurance Company (NAIC #12190), a New York insurance company
                headquartered at 6100 4th Ave. S. #200 Seattle, WA 98108, or Independence American Insurance Company
                (NAIC #26581), a Delaware insurance company located at 11333 N.
                Scottsdale Rd. #160 Scottsdale, AZ 85254. Pets Best Insurance Services,
                LLC (NPN #8889658, CA agency #0F37530) is a licensed insurance agency located at 11333 N. Scottsdale Rd. #160 Scottsdale, AZ 85254.
                Each insurer has sole financial responsibility for its own products. Please refer to your declarations page to determine the
                underwriter for your policy. Terms and conditions apply. See your policy for details.
              </Text>
              <Text>
                PetPlace is not a licensed insurance agency nor an underwriter of insurance but may receive compensation for referrals.
              </Text>
            </div>
          </>)}
          {showAPIFailureScreen && (<div className='ui-pet-best-insurance-card__failure-screen'>
            <span className='ui-pet-best-insurance-card__failure-description'>
              <Text type={Text.Types.headline}>
                We’re having trouble loading pet insurance options.
              </Text>
              <Text type={Text.Types.body}>
                It looks like we couldn’t retrieve pet insurance plans right now.
                You can continue registering your pet’s microchip or try again.
              </Text>
            </span>
            <div className='ui-pet-best-insurance-card__actions'>
              <Button color={Button.Colors.tertiary} {...tryAgainButtonProps}>
                <div className="ui-new-purchase-plan-card__add_to_cart">
                  <Icon type='cached' />
                  <span>Try Again</span>
                </div>
              </Button>
              <Button color={Button.Colors.tertiary} {...reviewPageButtonProps}>
                Continue Without Insurance
              </Button>
            </div>
          </div>)}
          {showSuccessScreen && (<div className='ui-pet-best-insurance-card__success-screen'>
            <span className='ui-pet-best-insurance-card__success-description'>
              <Icon type='check_circle_outlined' />
              <Text type={Text.Types.headline}>
                You’re All Set!
              </Text>
              <Text type={Text.Types.body}>
                Your payment was submitted successfuly and a confirmation from Pets Best is on its way to {email}
              </Text>
            </span>
            <div className='ui-pet-best-insurance-card__actions'>
              <Button color={Button.Colors.tertiary} {...reviewPageButtonProps}>
                Complete Registration
              </Button>
            </div>
          </div>)}
        </PaperContent>
      </Paper>
    )
  }
}
